import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEOMeta from '../components/SEOMeta';

function ShippingPage() {
  return (
    <div className="about-page">
      <SEOMeta
        title="Shipping and Delivery"
        description="Hercles Global delivery information for Nairobi and Kenya. Learn about delivery timelines, order confirmation and shipping support."
        canonical="/shipping"
      />
      <Header />
      <main className="about-inner">
        <section className="about-hero">
          <h1>Shipping and Delivery</h1>
          <p>We deliver electronics, laptops, phones, and accessories across Nairobi and the rest of Kenya.</p>
        </section>

        <section className="about-section">
          <h2>Delivery Timelines</h2>
          <ul>
            <li>Nairobi and nearby areas: 1-2 business days</li>
            <li>Other counties in Kenya: 2-4 business days</li>
            <li>Large or special-order items may need confirmation before dispatch</li>
          </ul>
        </section>

        <section className="about-section">
          <h2>Order Confirmation</h2>
          <p>After checkout, our team contacts you by phone or WhatsApp to confirm payment, delivery address, and timing.</p>
        </section>

        <section className="about-section">
          <h2>Delivery Support</h2>
          <p>For urgent orders or delivery questions, call or WhatsApp <a href="tel:+254724474097">+254 724 474097</a>.</p>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default ShippingPage;
